import aluminium from './aluminum.html';
import metal from './metal.html';
import plastic from './plastic.html';
import wood from './wood.html';
import acrylic from './acrylic.html';
import led from './led.html';
export default {
  aluminium,
  metal,
  plastic,
  wood,
  acrylic,
  led
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/templates/signs/index.js
 **/